import React, { useEffect } from 'react'
import { Form, Input, Modal } from 'antd'
import { Icon } from '@iconify/react'

import styles from './CollectionFormModal.module.css'

const CollectionFormModal = ({
    open,
    mode = 'create',
    initialValues,
    loading,
    onCancel,
    onSubmit,
}) => {
    const [form] = Form.useForm()
    const isEdit = mode === 'edit'

    useEffect(() => {
        if (open) {
            form.setFieldsValue({
                name: initialValues?.name || '',
                description: initialValues?.description || '',
            })
        } else {
            form.resetFields()
        }
    }, [open, initialValues, form])

    const handleSubmit = (values) => {
        onSubmit?.(values)
    }

    return (
        <Modal
            title={
                <div className={styles.modalHeader}>
                    <div className={styles.modalHeaderLeft}>
                        <div className={styles.modalHeaderIcon}>
                            <Icon
                                icon="mdi:folder-multiple-outline"
                                width={20}
                                height={20}
                            />
                        </div>
                        <div>
                            <div className={styles.modalHeaderTitle}>
                                {isEdit
                                    ? 'Edit collection'
                                    : 'Create collection'}
                            </div>
                            <div className={styles.modalHeaderSubtitle}>
                                {isEdit
                                    ? 'Update your collection details.'
                                    : 'You will be the owner and can invite members later.'}
                            </div>
                        </div>
                    </div>
                </div>
            }
            open={open}
            onCancel={onCancel}
            footer={
                <div className={styles.modalFooter}>
                    <div className={styles.formActions}>
                        <button
                            type="button"
                            onClick={onCancel}
                            className={styles.cancelButton}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            disabled={loading}
                            onClick={() => form.submit()}
                            className={styles.submitButton}
                        >
                            {isEdit
                                ? loading
                                    ? 'Saving...'
                                    : 'Save changes'
                                : loading
                                  ? 'Creating...'
                                  : 'Create collection'}
                        </button>
                    </div>
                </div>
            }
            width={520}
            className="co7-collection-modal"
            destroyOnHidden
            centered
        >
            <Form
                form={form}
                layout="vertical"
                requiredMark
                autoComplete="off"
                className="co7-collection-form"
                onFinish={handleSubmit}
            >
                <Form.Item
                    name="name"
                    label="Collection name"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter a collection name',
                        },
                        { max: 80, message: 'Name is too long' },
                    ]}
                >
                    <Input placeholder="e.g. Product Research" />
                </Form.Item>
                <Form.Item
                    name="description"
                    label="Description"
                    rules={[{ max: 240, message: 'Description is too long' }]}
                >
                    <Input.TextArea
                        placeholder="What is this collection for?"
                        rows={4}
                        showCount
                        maxLength={240}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default CollectionFormModal
